// Copyright © 2021 Move Closer
import { __decorate } from "tslib";
import { Component } from 'vue-property-decorator';
import { AbstractSimpleModuleUi, abstractSimpleModuleUiOptions } from '../_abstract/ui';
/**
 * Component capable of rendering the `HRModule`'s contents.
 *
 * @author Stanisław Gregor <stanislaw.gregor@movecloser.pl>
 */
let HRModuleUi = class HRModuleUi extends AbstractSimpleModuleUi {
};
HRModuleUi = __decorate([
    Component({ ...abstractSimpleModuleUiOptions, inheritAttrs: false, name: 'HRModuleUi' })
], HRModuleUi);
export { HRModuleUi };
